export const LinesSquare = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 11L23 11" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M9 16L23 16" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M9 21L23 21" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<rect x="5" y="5" width="22" height="22" rx="1" stroke="currentColor" stroke-width="2"/>
</svg>`;
